import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { environment } from 'src/environments/environment';
import { Constant } from '../constant';
import HelperUtil from '../utils/helper-util';
import { ImageUtil } from '../utils/image.util';
import { DialogService } from './dialog.service';
import { EventManagerService } from './event-manager.service';
@Injectable({ providedIn: 'root' })
export class UploaderService {
    uploader: FileUploader;
    allowedMimeType = [];
    isErrorUpload: boolean = false;
    broadcast: string = 'no-name';
    constructor(
        private dialogService: DialogService,
        private sessionStorage: SessionStorageService,
        private eventManager: EventManagerService
    ) {}
    initUploader(api, broadcast, allowedFileType?, photoType?) {
        const attachedFiles = [];
        const config: any = {
            isHTML5: true,
            url: api,
            authToken: this.sessionStorage.retrieve('TOKEN'),
            maxFileSize: Constant.MAX_FILE_SIZE,
            autoUpload: false,
            headers: [
            ]
        };
        if (allowedFileType) {
            config.allowedFileType = allowedFileType;
        }
        const uploader =  new FileUploader(config);
        // clientApiKey: 'FMARKET-ANGULAR-KEY2',
        uploader.onAfterAddingFile = (item: any) => {
            item.withCredentials = false; 
            this.isErrorUpload = false;
            this.parseFileToDataUrl(item.file.rawFile, uploader);
        }
        uploader.onBuildItemForm = (fileItem, form)=>{
            var image: any = document.getElementById('fileUpload');
            const base64 = ImageUtil.scale(image.src, 300);
            form.append(Constant.clientApiKey, Constant.clientApiKey_value_report);
            form.append(Constant.requestId, Date.now());
            form.append(Constant.applyOriginalFileName, true);
            form.append(Constant.fileType, Constant.fileTypeNormal);
            form.append(Constant.photoType, photoType || 'PASSPORT'); //  PASSPORT, PASSPORT_2ND_CONTACT, AVATAR, IMAGE_PRODUCT
            form.append(Constant.base64File, base64);
            form.delete('file');
            return {fileItem, form}
        };
        uploader.onWhenAddingFileFailed = (item, filter) => {
            let message = 'Error Upload';
            switch (filter.name) {
            //   case 'queueLimit':
            //     message = 'Only uploading max ' + environment.MAX_QUEUE_LIMIT + 'files';
            //     break;
              case 'fileSize':
                // tslint:disable-next-line:max-line-length
                message = 'Hình ảnh vượt quá ' + HelperUtil.formatBytes(config.maxFileSize) + ' cho phép';
                break;
              case 'fileType':
                message = 'Chỉ cho phép các loại sau: ' + this.getFileName(allowedFileType);
                break;
              default:
                message = 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
                break;
            }
            this.dialogService.showError(message);
        };
        uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            if (this.isErrorUpload) {
                return;
            }
            const data = (JSON.parse(response || '{}') || {}).data || {};
            const imagePath = data.listFileUploaded[0] ? data.listFileUploaded[0].url : '';
            const file = data.listFileUploaded[0];
            let type = 'file';
            if (file.fileName.includes('.doc') || file.fileName.includes('.docx')) {
                type = 'word';
            } else if (file.fileName.includes('.xls') || file.fileName.includes('.xlxs')) {
                type = 'excel';
            } else if (file.fileName.includes('.pdf')) {
                type = 'pdf';
            } else if (file.fileName.includes('.jpg') || file.fileName.includes('.jpeg') || file.fileName.includes('.png') || file.fileName.includes('.gif')) {
                type = 'image';
            }
            file.type = type;
            const exist = attachedFiles.some(item => item.fileName === file.fileName);
            if (exist) {
                this.dialogService.showError('File đã tồn tại.');
                return;
            }
            attachedFiles.push(file);
            this.checkExistUrlImage(broadcast, {
                file: file,
                files: attachedFiles,
                imagePath: file.url
            }, 1)
        };
        uploader.onBeforeUploadItem = (item: any) => {
            
            item.withCredentials = false; 
            const split = item.file.name.split('.');
            const extension = split.pop();
            const name = split.join('.') + '_' + Date.now() +  '.' + extension;
            item.file.name = name 
            this.isErrorUpload = false;
            this.eventManager.broadcast({
                name: 'upload-file',
                content: {}
            });
            this.eventManager.broadcast({
                name: broadcast + '-upload-file',
                content: {
                    file: item.file
                }
            });
            return item;
        };
        uploader.onErrorItem = (item: any, response: any, status: any, headers: any) => {
            this.isErrorUpload = true;
            if (!response) {
                return;
            }
            const error = JSON.parse(response);
            this.dialogService.showError(error.detail);
        };
        return uploader;
    }
    parseFileToDataUrl(file, uploader) {
        if (FileReader && file) {
            var fr = new FileReader();
            fr.onload = () => {
                const image: any = document.getElementById('fileUpload');
                image.src = fr.result;
                setTimeout(() => {
                    uploader.uploadAll();
                }, 1000)
            }
            fr.readAsDataURL(file);
        }
    }
    checkExistUrlImage(broadcast, content, time) {
        const fileUrl = content.file.fileUrl  || content.file.url  || '';
        if (!(fileUrl.includes('png') || fileUrl.includes('jpg') || fileUrl.includes('jpeg'))) {
            this.eventManager.broadcast({
                name: broadcast,
                content
            });
        } else {
            var image = new Image();
            image.src = content.imagePath;
            setTimeout(() => {
                if (image.width == 0 && time < 20) {
                    setTimeout(() => {
                        time++;
                        this.checkExistUrlImage(broadcast, content, time);
                    }, 500)
                } else if (image.width > 0) {
                    this.eventManager.broadcast({
                        name: broadcast,
                        content
                    });
                } 
            }, 500);
        }
        if (time === 20) {
            this.eventManager.broadcast({
                name: 'upload-fail',
                content: {}
            });
            this.eventManager.broadcast({
                name: broadcast + '-upload-fail',
                content: {}
            });
        }
    }
    getFileName(allowedFileType) {
        const array = (allowedFileType || []).map((type) => {
            let txt = '';
            switch (type) {
                case 'image':
                    txt = 'png, jpg, jpeg';
                break;
            };
            return txt;
        })
        return array.join(', ');
    }
}
// List of allowedFileTypes values:

// application
// image
// video
// audio
// pdf
// compress
// doc
// xls
// ppt